import { render, staticRenderFns } from "./ProfileBroker.vue?vue&type=template&id=87c07f0a&"
import script from "./ProfileBroker.vue?vue&type=script&lang=js&"
export * from "./ProfileBroker.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBroker.vue?vue&type=style&index=0&id=87c07f0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports